// src/pages/SubscriptionSuccess.tsx
import { useNavigate } from 'react-router-dom'
import { GiGlassCelebration } from "react-icons/gi";
import { Button } from '../components/ui/atoms/Button/Button'

export default function SubscriptionSuccess() {
  const navigate = useNavigate()

  return (
    // Use min-h-screen (or h-screen) to ensure full viewport height
    <div className="min-h-screen flex flex-col items-center justify-center p-6 bg-gradient-to-b from-brandPurpleDark to-brandPurpleLight">
      {/* Celebratory icon */}
      <div className="text-7xl mb-4 animate-bounce">
        <GiGlassCelebration className="text-yellow-200" />
      </div>

      {/* Headline */}
      <h1 className="text-3xl text-yellow-100 font-extrabold mb-5 text-gray-800">
        You’re All Set!
      </h1>

      {/* Message */}
      <p className="tsxt-lg text-gray-900 mb-6 text-center max-w-sm">
        Your PanPals Premium membership is active. Thanks for subscribing. Now let's cook.
      </p>

      {/* Primary action: go customize preferences */}
      <Button
        variant="outline-rounded-black"
        onClick={() => navigate('/app/settings/preferences')}
        className="w-full max-w-xs bg-black py-3"
      >
        Set your Dietary Preferences
      </Button>

      {/* Secondary action: explore recipes */}
      <Button
        variant="outline-rounded"
        onClick={() => navigate('/app/home')}
        className="mt-3 w-full max-w-xs py-3 mb-20"
      >
        Explore Recipes
      </Button>
    </div>
  )
}